import { gql, useQuery, QueryHookOptions } from '@apollo/client';
import { GAME_TYPES_TYPE } from '../../../../constants/constants';
import { AIDifficultyLevel } from '../../PlayWithAI/useJoinAiGameMutation.gql';

export const query = gql`
  query AIPracticeGamesByUserHiveAndGameType($userId: String!, $gameType: GameType) {
    aiPracticeGamesByUserHiveAndGameType(userId: $userId, gameType: $gameType) {
      _id
      userId
      gameType
      aiDifficultyLevel
      played
      won
      createdAt
      updatedAt
    }
  }
`;

export interface GymAIPracticeGameType {
  _id: string;
  userId: string;
  gameType: GAME_TYPES_TYPE;
  aiDifficultyLevel: AIDifficultyLevel;
  played: number;
  won: number;
  createdAt: string;
  updatedAt: string;
}

export interface RequestType {
  userId: string;
  gameType: GAME_TYPES_TYPE;
}

export interface QueryType {
  aiPracticeGamesByUserHiveAndGameType: GymAIPracticeGameType[];
}

export function useAIPracticeGamesQuery(
  request: RequestType,
  options?: QueryHookOptions<QueryType, RequestType>,
) {
  return useQuery<QueryType, RequestType>(query, {
    variables: request,
    ...options,
  });
}
